export const GET_AZURE_REFRESH = "GET_AZURE_REFRESH";
export const GET_AZURE_REFRESH_SUCCESS = "GET_AZURE_REFRESH_SUCCESS";
export const GET_AZURE_REFRESH_FAIL = "GET_AZURE_REFRESH_FAIL";
export const GET_AZURE_CLOUD_RESOURCES_SUCCESS = "GET_AZURE_CLOUD_RESOURCES_SUCCESS";
export const GET_AZURE_CLOUD_RESOURCES_FAIL = "GET_AZURE_CLOUD_RESOURCES_FAIL";
export const GET_AZURE_CLOUD_RESOURCES = "GET_AZURE_CLOUD_RESOURCES";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS";
export const GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL = "GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL";

export const GET_AZURE_NOTIFICATION_CHANNELS = "GET_AZURE_NOTIFICATION_CHANNELS";
export const GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS = "GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS";
export const GET_AZURE_NOTIFICATION_CHANNELS_FAIL = "GET_AZURE_NOTIFICATION_CHANNELS_FAIL";

export const POST_AZURE_CREATE_RESOURCE_ALERTS = "POST_AZURE_CREATE_RESOURCE_ALERTS";
export const POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS = "POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS";
export const POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL = "POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL";

export const POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING = 'POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING';
export const POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS = 'POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS';
export const POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL = 'POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL';

export const POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING = 'POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING';
export const POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS = 'POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS';
export const POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL = 'POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL';

export const POST_AZURE_RESOURCE_SERVICE_MAPPING = 'POST_AZURE_RESOURCE_SERVICE_MAPPING'
export const POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS = 'POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS'
export const POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL = 'POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL'

export const GET_ALL_ORG_AZURE_RESOURCE_TYPES = "GET_ALL_ORG_AZURE_RESOURCE_TYPES";
export const GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS = "GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS";
export const GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL = "GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL";


export const GET_USER_RESCAN_STATUS_AZURE = "GET_USER_RESCAN_STATUS_AZURE";
export const GET_USER_RESCAN_STATUS_AZURE_SUCCESS = "GET_USER_RESCAN_STATUS_AZURE_SUCCESS";
export const GET_USER_RESCAN_STATUS_AZURE_FAIL = "GET_USER_RESCAN_STATUS_AZURE_FAIL";